import { MultipleChoiceQuizData } from "./multipleChoiceQuizData";
import { TestCaseData } from "./testCaseData";
export class ExerciseData {
    constructor() {
        //All exercises
        this.id = "";
        this.index = -1; //Not deserialized, dynamically generated at load.
        this.name = "";
        this.type = "";
        //CodeCanvas
        this.information = "";
        this.documentations = new Array();
        this.concepts = new Array();
        this.goal = "";
        this.testCaseDatas = new Array();
        this.code = "";
        this.rootVariableName = "";
        //Concept Quiz
        this.question = "";
        this.questionField = "";
        this.answerField = "";
        this.answerConceptID = "";
        this.optionConceptIDs = new Array();
        //TextBlurb
        this.headerImage = "";
        this.text = "";
        this.buttonText = "";
        this.footerImage = "";
        //StepCodeCanvas
        this.allowBreakpoints = true;
        this.allowVariables = true;
        this.stepMilliseconds = 0;
        //Factory Quiz
        this.multipleChoiceQuizData = null;
    }
    deserialize(input) {
        this.id = input.id;
        this.name = input.name;
        this.type = input.type;
        //CodeCanvas
        this.information = input.information;
        this.documentations.length = 0;
        if (input.documentations) {
            for (const jsonDocumentation of input.documentations) {
                this.documentations.push(jsonDocumentation);
            }
        }
        this.concepts.length = 0;
        if (input.concepts) {
            for (const jsonConcept of input.concepts) {
                this.concepts.push(jsonConcept);
            }
        }
        this.goal = input.goal;
        this.testCaseDatas.length = 0;
        if (input.testCaseDatas) {
            for (const jsonTestCaseData of input.testCaseDatas) {
                const testCaseData = new TestCaseData().deserialize(jsonTestCaseData);
                this.testCaseDatas.push(testCaseData);
            }
        }
        this.code = input.code;
        this.rootVariableName = input.rootVariableName;
        //Concept Quiz
        this.question = input.question;
        this.questionField = input.questionField;
        this.answerField = input.answerField;
        this.answerConceptID = input.answerConceptID;
        this.optionConceptIDs = input.optionConceptIDs;
        //TextBlurb
        this.headerImage = input.headerImage;
        this.text = input.text;
        this.buttonText = input.buttonText;
        this.footerImage = input.footerImage;
        //StepCodeCanvas
        this.allowBreakpoints = input.allowBreakpoints;
        this.allowVariables = input.allowVariables;
        this.stepMilliseconds = input.stepMilliseconds;
        //QuizData
        if (input.multipleChoiceQuizData) {
            this.multipleChoiceQuizData = new MultipleChoiceQuizData();
            this.multipleChoiceQuizData.deserialize(input.multipleChoiceQuizData);
        }
        return this;
    }
}
